import { render, staticRenderFns } from "./FMICNoticiaslanzamientoNuestrasMejoras.vue?vue&type=template&id=4cc3df82"
import script from "./FMICNoticiaslanzamientoNuestrasMejoras.vue?vue&type=script&lang=js"
export * from "./FMICNoticiaslanzamientoNuestrasMejoras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports